export default __webpack_public_path__ + "static/media/image16.3caaceaf.jpg";